import type { ComputedRef } from 'vue'

import { computed } from 'vue'

import type { UserDisplayInfo } from '@/domains/users/types/models/User.types'

import { getInitials } from '@/utils/string-util/getInitials'

/**
 * Get user initials from first and last name.
 * @example getUserInitials({ first_name: 'John', last_name: 'Doe' }) // 'JD'
 */
export const getUserInitials = (user: UserDisplayInfo | null | undefined): string => {
  if (!user) return ''
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim()
  return getInitials(fullName)
}

/**
 * Get user full name, preferring full_name property if available.
 * @example getUserFullName({ first_name: 'John', last_name: 'Doe' }) // 'John Doe'
 */
export const getUserFullName = (user: UserDisplayInfo | null | undefined): string => {
  if (!user) return ''
  return user.full_name || `${user.first_name || ''} ${user.last_name || ''}`.trim()
}

export const useUserHelper = (user: UserDisplayInfo) => {
  const fullName: ComputedRef<string> = computed(() => `${user.first_name} ${user.last_name}`)

  return {
    fullName
  }
}
